<div class="flex flex--column" data-hj-suppress>
  <div class="flex flex--align-baseline border-bottom mobile-flex pax-name">
    <ng-container *ngIf="!modifyCheckIn && extendedPassengerInfo.isCheckedIn">
      <div class="ps-medium-x ps-small-y fill flex g-xsmall">
        <div class="flew--nogrow">
          <fcom-icon
            class="icon-medium"
            [class.grey-600-text]="extendedPassengerInfo.isCheckedIn"
            [name]="SvgLibraryIcon.ADULT_INFANT"
          ></fcom-icon>
        </div>
        <div class="flex flex--middle flex--wrap g-xsmall spacer">
          <span class="font-heading-5" [class.grey-600-text]="extendedPassengerInfo.isCheckedIn"
            >{{ extendedPassengerInfo.firstName }} {{ extendedPassengerInfo.lastName }}</span
          >
          <span
            class="medium-type font-body-1 flex--self-end spacer"
            [class.grey-600-text]="extendedPassengerInfo.isCheckedIn"
            >{{ 'passenger.' + extendedPassengerInfo.paxTypeKey | finLocalization | titlecase }}
            <span *ngIf="accompanyingInfant"
              >({{
                'passenger.withInfant'
                  | finLocalization
                    : { withInfantFullName: accompanyingInfant.firstName + ' ' + accompanyingInfant.lastName }
                  | finToLowerCase: ''
              }})</span
            >
            <span *ngIf="accompanyingAdult"
              >({{
                'passengerReview.withAdult'
                  | finLocalization
                    : { withAdultFullName: accompanyingAdult.firstName + ' ' + accompanyingAdult.lastName }
                  | finToLowerCase: ''
              }})</span
            ></span
          >
          <fcom-tag [theme]="TagTheme.SUCCESS">
            <fcom-icon class="icon-small ms-xxsmall-r" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
            <span>{{ 'MMB.checkIn.funnel.steps.passengers.checkInCompleted' | finLocalization }}</span>
          </fcom-tag>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!modifyCheckIn && !extendedPassengerInfo.isCheckedIn">
      <div class="ps-medium-x ps-small-y flex flex--middle flex--wrap g-xsmall flex-1 fill" [formGroup]="formGroup">
        <fcom-checkbox
          class="fill"
          [contentFullWidth]="true"
          [formControlName]="extendedPassengerInfo.id"
          [showUnselectedIcon]="!extendedPassengerInfo.hasUnrecoverableReason"
        >
          <div class="flex flex--middle flex--wrap g-xsmall fill">
            <div class="flex flex--middle flex--wrap g-xsmall spacer">
              <fcom-icon
                class="icon-medium"
                [name]="SvgLibraryIcon.ADULT_INFANT"
                *ngIf="extendedPassengerInfo.hasUnrecoverableReason && accompanyingInfant"
              ></fcom-icon>
              <fcom-icon
                class="icon-medium"
                [name]="SvgLibraryIcon.SINGLE_PAX"
                *ngIf="extendedPassengerInfo.hasUnrecoverableReason && !accompanyingInfant && !accompanyingAdult"
              ></fcom-icon>
              <span class="font-heading-5"
                >{{ extendedPassengerInfo.firstName }} {{ extendedPassengerInfo.lastName }}</span
              >
              <span class="font-body-1 medium-type"
                >{{ 'passenger.' + extendedPassengerInfo.paxTypeKey | finLocalization | titlecase }}
                <span *ngIf="accompanyingInfant"
                  >({{
                    'extendedPassengerInfo.withInfant'
                      | finLocalization
                        : { withInfantFullName: accompanyingInfant.firstName + ' ' + accompanyingInfant.lastName }
                      | finToLowerCase: ''
                  }})</span
                ><span *ngIf="accompanyingAdult"
                  >({{
                    'passengerReview.withAdult'
                      | finLocalization
                        : { withAdultFullName: accompanyingAdult.firstName + ' ' + accompanyingAdult.lastName }
                      | finToLowerCase: ''
                  }})</span
                ></span
              >
            </div>
            <ng-container
              *ngIf="formGroup.get(extendedPassengerInfo.id).disabled && !extendedPassengerInfo.hasUnrecoverableReason"
            >
              <div class="font-body-2 regular-type" *ngIf="!extendedPassengerInfo.isCheckedIn">
                {{ 'MMB.checkIn.state.notCheckedIn' | finLocalization }}
              </div>
              <div
                data-testid="not-allowed-to-use-state"
                class="font-body-2 regular-type"
                *ngIf="!extendedPassengerInfo.isAllowedToUseCheckIn"
              >
                {{ 'MMB.checkIn.state.notEligible' | finLocalization }}
              </div>
            </ng-container>
            <ng-container *ngIf="extendedPassengerInfo.hasUnrecoverableReason">
              <fcom-tag [theme]="TagTheme.WARNING">
                <fcom-icon class="icon-small ms-xxsmall-r" [name]="SvgLibraryIcon.SERVICE_DESK"></fcom-icon>
                <span>{{ 'MMB.checkIn.funnel.steps.passengers.checkInAtAirport' | finLocalization }}</span>
              </fcom-tag>
            </ng-container>
          </div>
        </fcom-checkbox>
      </div>
    </ng-container>
    <ng-container *ngIf="modifyCheckIn">
      <div class="ps-medium-x ps-small-y flex flex--middle flex--wrap g-xsmall flex-1 fill" [formGroup]="formGroup">
        <fcom-checkbox class="fill" [contentFullWidth]="true" [formControlName]="extendedPassengerInfo.id">
          <div class="flex flex--middle flex--wrap g-xsmall fill">
            <div class="flex flex--middle flex--wrap g-xsmall spacer">
              <span class="font-heading-5"
                >{{ extendedPassengerInfo.firstName }} {{ extendedPassengerInfo.lastName }}</span
              >
              <span class="font-body-1 flex--align-self-end medium-type"
                >{{ 'passenger.' + extendedPassengerInfo.paxTypeKey | finLocalization | titlecase }}
                <span *ngIf="accompanyingInfant"
                  >({{
                    'passenger.withInfant'
                      | finLocalization
                        : { withInfantFullName: accompanyingInfant.firstName + ' ' + accompanyingInfant.lastName }
                      | finToLowerCase: ''
                  }})</span
                ><span *ngIf="accompanyingAdult"
                  >({{
                    'passengerReview.withAdult'
                      | finLocalization
                        : { withAdultFullName: accompanyingAdult.firstName + ' ' + accompanyingAdult.lastName }
                      | finToLowerCase: ''
                  }})</span
                ></span
              >
            </div>
            <fcom-tag [theme]="TagTheme.SUCCESS">
              <fcom-icon class="icon-small ms-xxsmall-r" [name]="SvgLibraryIcon.CHECKMARK"></fcom-icon>
              <span>{{ 'MMB.checkIn.funnel.steps.passengers.checkInCompleted' | finLocalization }}</span>
            </fcom-tag>
          </div>
        </fcom-checkbox>
      </div>
    </ng-container>
  </div>

  <div class="flex-1 font-body-1">
    <div class="flex flex--center mobile-flex">
      <div class="flex-1 flex--self-start ms-large-x info-section" [class.border-bottom-dashed]="showEdit">
        <div>
          <div *ngIf="extendedPassengerInfo.dateOfBirth" class="ps-xsmall-t">
            {{ 'passengerReview.dateOfBirth' | finLocalization }}
            {{ extendedPassengerInfo.dateOfBirth | finDateFormat: 'DATE' }}
          </div>
          <div *ngIf="extendedPassengerInfo.email" class="ps-xsmall-t" data-testid="pasenger-info-box-email">
            <fcom-icon class="icon-small" [name]="SvgLibraryIcon.EMAIL"></fcom-icon>
            {{ extendedPassengerInfo.email | lowercase }}
          </div>
          <div
            *ngIf="extendedPassengerInfo.phoneNumbers?.length > 0"
            class="ps-xsmall-t"
            data-testid="pasenger-info-box-phone-numbers"
          >
            <ng-container *ngFor="let phone of extendedPassengerInfo.phoneNumbers; let first = first"
              ><span *ngIf="!first"> / </span
              ><span
                ><fcom-icon class="icon-small" [name]="SvgLibraryIcon.PHONE"></fcom-icon> (+{{ phone?.countryPrefix }})
                {{ phone?.number }}</span
              ></ng-container
            >
          </div>
          <fin-passenger-ff-cards [cards]="extendedPassengerInfo.cards"></fin-passenger-ff-cards>

          <div
            *ngIf="(!extendedPassengerInfo.cards || extendedPassengerInfo.cards.length === 0) && showEdit"
            class="ps-xsmall-t flex"
          >
            <div>
              <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.FINNAIR_PLUS"></fcom-icon>
              <span class="ps-xxsmall-r"
                >{{ 'MMB.checkIn.funnel.steps.passengers.addToFfTitle' | finLocalization }}
              </span>
            </div>
            <span class="flex nordic-blue-400-text">
              {{ 'MMB.checkIn.funnel.steps.passengers.addToFfButton' | finLocalization }}
            </span>
          </div>
        </div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="flex--nogrow ps-medium-t flex--self-end mobile-padding" *ngIf="showEdit">
    <div class="ms-medium-x">
      <fcom-button
        (clickBtn)="edit.emit()"
        [text]="'actions.edit' | finLocalization"
        [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
        [icon]="{ name: SvgLibraryIcon.EDIT, position: IconPosition.RIGHT }"
      ></fcom-button>
    </div>
  </div>
</div>
